export default __webpack_public_path__ + "static/media/reports.215e60e6.svg";